import {useQuery} from '@apollo/react-hooks';

import {safelyGetGraphQLErrorMessage, makeDataDangerous} from 'nutshell-core/utils/graphql-errors';

import type {
    GetDripSequencesDashboard_dripsDashboard as DripSequencesDashboard,
    GetDripSequencesDashboard as GetDripSequencesDashboardQuery,
    GetDripSequencesDashboardVariables as GetDripSequencesDashboardQueryVariables,
    DashboardInput,
} from 'nutshell-graphql-types';

import GET_DRIP_SEQUENCES_DASHBOARD from '../queries/get-drip-sequences-dashboard.graphql';

export const useGetDripSequencesDashboard = (
    input: DashboardInput
): {
    isLoading: boolean;
    errorMessage: string | null | undefined;
    dripSequencesDashboard: DripSequencesDashboard;
} => {
    const {loading, data, error} = useQuery<
        GetDripSequencesDashboardQuery,
        GetDripSequencesDashboardQueryVariables
    >(GET_DRIP_SEQUENCES_DASHBOARD, {
        variables: {input},
        notifyOnNetworkStatusChange: true,
    });

    const {dripsDashboard} = makeDataDangerous(data);

    return {
        isLoading: loading,
        // @ts-expect-error
        errorMessage: safelyGetGraphQLErrorMessage(error),
        dripSequencesDashboard: dripsDashboard,
    };
};
